<script setup lang="ts">
/**
 * „Jak to działa" — sekcja wymagana przez E6.3.
 *
 * W tym modelu klient NIE kupuje sam: nie ma koszyka ani płatności, a jedyną
 * ścieżką jest zapytanie o wycenę. Bez wyjaśnienia procesu odwiedzający nie
 * wie, co się stanie po kliknięciu „Zapytaj o wycenę" ani kiedy dostanie
 * odpowiedź — a to jest dokładnie ten moment, w którym rezygnuje.
 *
 * Treść jest wpisana w kodzie świadomie (app/utils/catalogHowItWorks.ts —
 * wspólna z zakładką na karcie produktu): opisuje proces obsługi, nie
 * asortyment, więc nie zmienia się przy każdej publikacji katalogu z EasyItem.
 * Gdy klientka zechce ją redagować sama, przenosimy ją do treści strony
 * głównej (panel).
 */
import { CATALOG_HOW_IT_WORKS_STEPS as steps } from '~~/app/utils/catalogHowItWorks'
</script>

<template>
  <section class="how-it-works container">
    <h2 class="section-title">
      Jak to działa
    </h2>

    <ol class="how-it-works__steps">
      <li
        v-for="(step, index) in steps"
        :key="step.title"
        class="how-it-works__step"
      >
        <span
          class="how-it-works__number"
          aria-hidden="true"
        >{{ index + 1 }}</span>
        <h3 class="how-it-works__title">
          {{ step.title }}
        </h3>
        <p class="how-it-works__text">
          {{ step.text }}
        </p>
      </li>
    </ol>
  </section>
</template>

<style scoped>
.how-it-works {
  margin: 3rem auto;
}

.how-it-works__steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  margin: 1.5rem 0 0;
  padding: 0;
  list-style: none;
  counter-reset: none;
}

.how-it-works__step {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.how-it-works__number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: var(--color-accent, #151515);
  color: var(--color-accent-contrast, #fff);
  font-weight: 700;
  font-size: 0.9375rem;
}

.how-it-works__title {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 600;
}

.how-it-works__text {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--color-text-muted, #6b6b6b);
}
</style>
